<template>
  <div class="wrap">
    <Head />
    <div class="part1"> 
      <p class="p1">
        <span>持之以恒</span>
        <span>事在人为</span>
      </p>

    </div>
    <div class="part2">
      <p class="tit1">{{$t('m_aboutus.part2.tit')}}</p>
      <p class="desc">江苏恒为信息科技有限公司(以下称为“恒为信息科技”) 是全国区块链和分布式记账技术标准化技术委员会(SAC/TC590)委员单位、江苏省区块链标准化技术委员会(JS-TC63)委员单位，中国区块链技术和产业发展论坛理事单位、可信区块链推进计划会员单位、江苏省区块链发展协会副理事长单位、无锡市区块链产业联盟会长单位。</p>
      <p class="desc">恒为信息科技是由海归学子创建的一家专注于区块链底层技术研发及产业应用部署的江苏省高新技术企业，无锡市专精特新企业，公司于2015年成立于无锡高新区，已通过ISO、ITSS，知识产权贯标等多项国家认证。恒为信息科技积极与大院大所及高校开展战略合作，内容包括区块链底层技研发及服务、区块链技术标准及测评，行业应用生态建设等。</p>
      <p class="desc">恒为信息科技发展至今成果斐然，参与编写了区块链国家标准1项和团体标准7项，牵头起草地方标准2项，参与编写国内首部《中国区块链与物联网融合创新应用蓝皮书》、《区块链应用操作员国家职业技术技能标准》，参与编写《区块链领导干部读本》、《江苏省工业区块链应用发展白皮书》、《无锡市政务区块链创新应用指南》、《江苏省区块链产业发展报告》、《江苏省工业区块链应用发展白皮书》、《无锡数字经济发展报告》等，2024年连续三年入选国家“产业区块链企业50强”，是无锡市区块链产业核心企业。</p>
    </div>
    <!-- 恒为信息 -->
    <div class="part3">
      <p class="tit1">{{$t('m_aboutus.part6.tit')}}</p>
      <p class="text1">{{$t('m_aboutus.part6.text1')}}</p>
      <p class="text2">{{$t('m_aboutus.part6.text2')}}</p>
    </div>
    <!-- 恒为大事件 -->
    <div class="part4">
      <p class="tit1">{{$t('m_aboutus.part5.tit')}}</p>
      <img
        src="../../assets/images/mobile/aboutus/part4.png"
        alt=""
      >
      <Timeline class="year">
        <TimelineItem
          v-for="(item, index) in historyList"
          :key="index"
        >
          <span
            slot="dot"
            class="time"
          >{{ item.year }}</span>
          <template v-for="(info, i) in item.list">
            <p :key="'d-'+index+'-'+i" class="data">{{ info.time }}</p>
            <p
              :key="'s-'+index+'-'+i"
              class="text"
              :class="{ texted: i === item.list.length - 1 }"
            >{{ info.str }}</p>
          </template>
        </TimelineItem>
      </Timeline>

    </div>
    <div class="part5">
      <p class="tit1">{{$t('m_aboutus.part3.tit')}}</p>
      <div class="swipe">
        <van-swipe
          indicator-color="white"
          :autoplay="3000"
        >
          <van-swipe-item>
            <div class="card">
              <img
                src="../../assets/images/mobile/aboutus/part5-1.png"
                alt=""
              >
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <img
                src="../../assets/images/mobile/aboutus/part5-2.png"
                alt=""
              >
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <img
                src="../../assets/images/mobile/aboutus/part5-3.png"
                alt=""
              >
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <img
                src="../../assets/images/mobile/aboutus/part5-4.png"
                alt=""
              >
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <img
                class="top"
                src="../../assets/images/mobile/aboutus/part5-5.png"
                alt=""
              >
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <img
                class="top"
                src="../../assets/images/mobile/aboutus/part5-6.png"
                alt=""
              >
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <img
                class="top"
                src="../../assets/images/mobile/aboutus/part5-7.png"
                alt=""
              >
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="card">
              <img
                class="top"
                src="../../assets/images/mobile/aboutus/part5-8.png"
                alt=""
              >
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="part6">
      <div class="card">
        <p class="tit">{{$t('m_aboutus.part4.tit')}}</p>
        <div class="row">
          <div class="left">
            <i class="iconfont icondianhua"></i>
          </div>
          <div class="right">固定电话：0510-85386599</div>
        </div>

        <div class="row">
          <div class="left">
            <i class="iconfont iconxinfeng"></i>
          </div>
          <div class="right">
            <p>技术合作：service@hwelltech.com</p>
            <p>商务洽谈：marketing@hwelltech.com</p>
            <p>战略部署：blockchain@hwelltech.com</p>
          </div>
        </div>

        <div class="row end">
          <div class="left">
            <i class="iconfont icondingwei"></i>
          </div>
          <div class="right">地址：无锡市新吴区菱湖大道111号天鹅座D栋19层</div>
        </div>

        <div class="erweima">
          <img
            src="../../assets/images/mobile/aboutus/erweima.png"
            alt
          />
          <p class="des">扫一扫二维码 关注我们</p>
        </div>
      </div>
      <div class="ditu">
        <img
          src="../../assets/images/mobile/aboutus/ditu.png"
          alt
        />
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/mobile/Head.vue";
import Foot from "../../components/mobile/Foot.vue";
import { Timeline, TimelineItem } from "iview";
import Vue from "vue";
import { Swipe, SwipeItem } from "vant";
Vue.use(Swipe).use(SwipeItem);
export default {
  data() {
    return {
      isCN: true,
      historyList: [
        {
          year: 2015,
          list: [
            { time: "2015", str: "公司成立" },
          ],
        },
        {
          year: 2016,
          list: [
            { time: "2016", str: "参加物博会" },
          ],
        },
        {
          year: 2017,
          list: [
            { time: "5月12日", str: "成立物联网+区块链联合实验室并发布行动计划" },
            { time: "8月", str: "发布《中国区块链与物联网融合创新应用蓝皮书》" },
            { time: "12月22日", str: "通过中国电子标准化研究院区块链系统技术测评" },
            { time: "12月底", str: "《中国区块链与物联网融合创新应用蓝皮书》的发布荣获\"2017年度无锡市软件和信息服务业（企业）\"十大最具影响力事件" },
          ],
        },
        {
          year: 2018,
          list: [
            { time: "9月17日", str: "承办2018世界物联网大会区块链与物联网融合发展峰会" },
          ],
        },
        {
          year: 2019,
          list: [
            { time: "4月17日", str: "启动国内首部物联网与区块链融合地方标准的编制" },
            { time: "8月", str: "成为中国区块链技术和产业发展论坛理事成员" },
            { time: "10月18日", str: "\"恒为链\"成功通过境内区块链信息服务备案" },
          ],
        },
        {
          year: 2020,
          list: [
            { time: "5月", str: "恒为信息科技成为第一届SACTC590《全国区块链和分布式记账技术标准化技术委员会》成员单位" },
            { time: "6月", str: "恒为信息科技在江苏省工信厅，无锡市政府，无锡市网信办，无锡市工信局的指导下发起成立无锡市区块链产业联盟，恒为信息科技成为首届会长单位" },
            { time: "12月", str: "恒为信息科技通过质量管理体系（ISO9001）、信息安全管理体系（ISO27001）、ITSS软件运维服务体系等多项认证" },
          ],
        },
        {
          year: 2021,
          list: [
            { time: "9月", str: "恒为信息科技支撑无锡市新吴区（高新区）工信局申报\"新吴区争创江苏省区块链产业发展集聚区\"工作，并于2021年12月成功入选江苏省区块链产业发展集聚区" },
            { time: "11月", str: "恒为信息科技支撑中共无锡市委网信办完成\"无锡市人民政府争创国家区块链创新应用试点（综合）\"申报工作，并于2022年1月成功入选国家区块链创新应用试点（综合）城市" },
            { time: "12月", str: "恒为信息科技\"高性能安全自主可控的区块链底层服务平台\"、\"基于区块链技术的政务数据治理网关\"荣获无锡市区块链应用项目优秀案例奖" },
            { time: "12月", str: "恒为信息科技承办\"链上未来——区块链安全发展和产业创新论坛\"" },
          ],
        },
        {
          year: 2022,
          list: [
            { time: "6月", str: "恒为信息科技担任江苏省区块链产业发展协会副理事长单位" },
            { time: "7月", str: "恒为信息科技入选中国\"产业区块链100强企业\"" },
            { time: "7月", str: "恒为信息科技\"自主安全可控的高性能区块链BaaS服务平台\"项目入围\"2022年江苏省区块链产业发展试点示范项目名单\"" },
            { time: "9月", str: "恒为信息科技入选JC/TC63江苏省区块链标准化技术委员会单位" },
            { time: "12月", str: "恒为信息科技新增7个区块链项目成功备案" },
          ],
        },
        {
          year: 2023,
          list: [
            { time: "5月", str: "恒为信息科技承建无锡市\"太湖链\"管理服务平台，支撑30个政务应用上链，支撑国家区块链创新应用试点城市建设" },
            { time: "5月", str: "恒为信息科技承接无锡市财政局，无锡市纪委监委牵头建设的无锡市镇（街）国有资产监管项目，并上升到全省试点" },
            { time: "8月", str: "恒为信息科技入选中国\"产业区块链100强企业\"" },
            { time: "9月", str: "恒为信息科技推动并参与无锡市高新区（新吴区）政府与中国电子技术标准化研究院合作建设的省级区块链测评中心" },
          ],
        },
        {
          year: 2024,
          list: [
            { time: "6月", str: "恒为信息科技承建的无锡市\"太湖链\"管理服务平台荣获2024江苏省优秀解决方案二等奖" },
            { time: "6月", str: "恒为信息科技承担无锡市政府举办的\"链上无锡\"区块链创新应用成果展现场解说" },
            { time: "10月", str: "恒为信息科技入选全国\"产业区块链企业50强\"" },
            { time: "10月", str: "恒为信息科技与中国电子技术标准化研究院共同建设无锡市高新区（新吴区）区块链测评中心" },
          ],
        },
        {
          year: 2025,
          list: [
            { time: "5月", str: "恒为信息科技积极与香港稳定币持牌机构建立战略合作伙伴关系，围绕稳定币跨境贸易支付结算、RWA（实物资产代币化）业务拓展开展合作，推动无锡相关能源企业开展绿色算力资产化RWA项目落地工作" },
            { time: "9月", str: "恒为信息科技做为技术支撑公司，派代表专家出席\"第七届长三角区块链应用创新大赛\"，开展\"新科技金融组\"项目复赛评审工作" },
            { time: "11月", str: "恒为信息科技积极响应无锡市人民政府办公室发布关于印发《无锡市中小企业数字化转型试点城市建设工作方案》的通知要求，推动10家以上企业探索运用区块链技术，打造多主体的供应链可信协同机制、可信可控的安全生产机制、产品全生命周期质量机制" },
          ],
        },
        {
          year: 2026,
          list: [
            { time: "4月", str: "恒为信息科技依托香港Web3产业集聚、国际规则接轨优势，与香港Web3协会达成深度生态战略合作伙伴关系，围绕区块链、Web3领域标准编制、规则共建、国际对标三大方向开展深度交流合作" },
            { time: "6月", str: "恒为信息科技依托香港合规持牌平台，启动区块链技术在场景支付、跨境清算结算领域试点落地工作，实现技术+合规+场景的全链路数据经济发展生态" },
          ],
        },
      ],
    };
  },
  components: {
    Head,
    Foot,
    Timeline,
    TimelineItem,
  },
  created() {
    this.getLang();
  },
  methods: {
    getLang() {
      //   this.isCN=localStorage.getItem('Lang')=='cn'?true:false;
      this.isCN = this.$i18n.locale == "cn" ? true : false;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/css/mixin';

.wrap {
}

.part1 {
  height: vw(650);
  width: vw(750);
  bg(url('../../assets/images/mobile/aboutus/bg.png'));
  overflow: hidden;
  margin-top: vw(98);

  .p1 {
    font-size: vw(40);
    color: rgba(221, 242, 255, 1);
    line-height: vw(40);
    margin-top: vw(80);
    text-align: center;

    span:nth-child(1) {
      display: inline-block;
      margin-right: vw(15);
    }

    span:nth-child(2) {
    }
  }
}

.part2 {
  part();
  padding: vw(80) 0 vw(50);

  .tit1 {
    tit3();
    margin-bottom: vw(32);
  }

  .desc {
    padding: 0 vw(35);
    font-size: vw(28);
    color: #666;
    line-height: vw(48);
    text-indent: 2em;
    margin-bottom: vw(30);
  }
}

.part3 {
  part();
  bg: url('../../assets/images/mobile/aboutus/part3.png');
  padding: vw(80) 0 vw(50);

  .tit1 {
    tit3();
    color: #fff;
    margin-bottom: vw(40);
  }

  .text1, .text2 {
    padding: 0 vw(39);
    font-size: vw(28);
    color: #fff;
    line-height: vw(40);
    margin-bottom: vw(30);
    text-indent: 2em;
  }
}

.part4 {
  part();
  background: rgba(249, 249, 249, 1);
  position: relative;

  .tit1 {
    tit3();
    margin-bottom: vw(40);
    color: rgba(68, 68, 68, 1);
  }

  img {
    width: 100%;
    position: absolute;
    top: vw(303);
  }

  .year {
    padding: 0 vw(35);

    /deep/.ivu-timeline-item-head {
      background-color: rgba(249, 249, 249, 1);
    }

    .time { // 标签
      display: inline-block;
      // vertical-align: top;
      width: vw(65);
      height: vw(65);
      color: rgba(42, 147, 255, 1);
      border-radius: 50%;
      background: #fff;
      text-align: center;
      border: none;
      box-shadow: 0 0 0 vw(2) rgba(42, 147, 255, 1);
      font-size: vw(24);
      line-height: vw(65);
    }

    /deep/.ivu-timeline-item-content {
      padding: vw(92) 0 vw(10) vw(40);
    }
  }

  /deep/.ivu-timeline-item-tail {
    top: vw(45);
    border-left: vw(2) solid rgba(218, 218, 218, 1);
  }

  .data {
    font-size: vw(24);
    line-height: vw(24);
    color: rgba(153, 153, 153, 1);
    margin-bottom: vw(12);
  }

  .text {
    font-size: vw(28);
    color: rgba(68, 68, 68, 1);
    line-height: vw(36);
    margin-bottom: vw(36);
  }

  .texted {
    margin-bottom: 0;
  }
}

.part5 {
  part();
  background-color: #fff;

  .tit1 {
    tit3();
    margin-bottom: vw(70);
  }

  .card {
    width: vw(629);
    height: vw(877);
    margin: 0 auto vw(50);

    img {
      width: 100%;
      height: auto;
    }

    .top {
      margin-top: vw(214);
    }
  }

  .swipe {
    /deep/.van-swipe { // 滑动底部导航
      .van-swipe__indicators {
        .van-swipe__indicator {
          width: vw(16);
          height: vw(16);
          background-color: transparent;
          border: 1px solid #2A93FF;
          opacity: 1;
        }

        .van-swipe__indicator--active {
          background: #2A93FF !important;
        }
      }
    }
  }
}

.part6 {
  part();
  background: rgba(249, 249, 249, 1);
  padding-bottom: 0;

  .card {
    margin: 0 vw(30);
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    padding: vw(40) vw(30);

    .tit {
      font-size: vw(32);
      line-height: vw(32);
      color: #333;
      margin-bottom: vw(28);
    }

    .row {
      display: flex;
      min-height: vw(40);

      .left {
        line-height: vw(48);
        width: vw(26);
        margin-right: vw(20);
        text-align: center;

        i {
          color: rgba(42, 147, 255, 1);
        }
      }

      .right {
        line-height: vw(48);
        flex: 1;
        font-size: vw(28);
        color: rgba(68, 68, 68, 1);
      }
    }

    .end {
      margin-bottom: vw(35);
    }

    .erweima {
      width: 100%;
      display: flex;
      padding-top: vw(40);
      border-top: 1px solid rgba(198, 198, 198, 1);

      img {
        width: vw(140);
        height: vw(140);
      }

      .des {
        flex: 1;
        font-size: vw(28);
        line-height: vw(28);
        color: rgba(68, 69, 76, 1);
        margin: vw(55) 0 0 vw(30);
        vertical-align: top;
      }
    }
  }

  .ditu {
    width: vw(750);
    height: vw(522);
    margin-top: vw(28);

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>